import { fetchAuthSession } from 'aws-amplify/auth';

/** Read the configured pool's token; ended credentials return to the login gate. */
export async function currentAccessToken(): Promise<string | null> {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.accessToken?.toString() ?? null;
  } catch (error) {
    const name = error instanceof Error ? error.name : '';
    if ([
      'UserUnAuthenticatedException', 'NotAuthorizedException', 'TokenRefreshException',
      'TokenRevokedException', 'UserNotFoundException',
      'PasswordResetRequiredException', 'UserNotConfirmedException',
      'RefreshTokenReuseException',
    ].includes(name)) return null;
    // Connectivity, throttling, and configuration failures are not sign-outs.
    throw error;
  }
}
